<template>
    <div>
    <div class="l-footer-wrap">
        <div class="l-footer">
            <strong class="copyright">&copy; XEOGEN,INC. All Rights Reserved.</strong>
            <a href="/personalInfo" class="personal-info">개인정보 처리방침</a>
            <a href="mailto:contact@xeogen.com" class="email">contact@xeogen.com</a>            
        </div>
    </div>
    <!-- <button class="btn-top"></button> -->
    <a href="javascript:;" class="btn-top"></a>
    <hr>
    <!--LAYER[s]-->
    <!-- <div class="project-layer-wrap" style="display:none;">
        <div class="project-layer">            
            <button class="close" v-on:click= goClose >닫기</button>
        </div>			
    </div> -->
    <!--LAYER[e]-->
</div>     
</template>
<script>
var st;
export default {
name: 'App',
data(){
    return{
            //currentRoute: window.location.pathname  
    }
},
mounted: function(){
    //var $projectLayerWrap = $('.project-layer-wrap');       
    $('.btn-top').on('click',function(){           
        $('html,body').scrollTop(0);
        // if(!$projectLayerWrap.is(':visible')){
        //     $('html,body').scrollTop(0);
        // }else{
        //     $projectLayerWrap.scrollTop(0);
        // }     
        //alert('click');
    });

    // $('.recently-project').on('click','a',function(){
    //     st = $(window).scrollTop();
    // });

        
},
    methods:{
        // goClose:function(){
        // var cUrl = window.location.href;
        // if(cUrl.indexOf('uiux') >0){
        //         this.$router.push('/uiux');
        // }else{
        //         this.$router.push('/main');
        // }
        //this.$router.replace(this.currentRoute);
        // $(".project-layer-wrap").hide();
        // $("body").removeAttr('style');
        //$('html,body').scrollTop(st);
        //}
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue